import React from 'react';
import ReactDOM from 'react-dom/client';
import MasalaMandir from './MasalaMandir.jsx';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <MasalaMandir />
  </React.StrictMode>
);